export interface ChipSelectOption {
  label: string;
  value: string;
}

export type ChipSelectVariant = 'lumen' | 'volt' | 'earth' | 'grey' | 'yellow' | 'success' | 'error' | 'palmetto';

interface VariantConfig {
  buttonClass: string;
  panelBg: string;
  panelBorder: string;
  /** Class applied to the currently-selected (or keyboard-focused) option row. */
  selectedOptionClassName: string;
}

export const variantConfig: Record<ChipSelectVariant, VariantConfig> = {
  lumen: {
    buttonClass:
      'bg-chip-canvas-default-idle border-chip-border-default-idle text-text-primary hover:bg-chip-canvas-default-hover',
    panelBg: 'var(--chip-canvas-default-idle)',
    panelBorder: 'var(--chip-border-default-idle)',
    selectedOptionClassName: 'bg-chip-canvas-selected-idle',
  },
  volt: {
    buttonClass:
      'bg-tag-container-default-volt border-tag-container-default-volt text-tag-text-default-volt hover:opacity-80',
    panelBg: 'var(--tag-container-default-volt)',
    panelBorder: 'var(--tag-container-default-volt)',
    selectedOptionClassName: 'bg-tag-container-inverted-volt text-tag-text-inverted-volt',
  },
  earth: {
    buttonClass:
      'bg-tag-container-default-earth border-tag-container-default-earth text-tag-text-default-earth hover:opacity-80',
    panelBg: 'var(--tag-container-default-earth)',
    panelBorder: 'var(--tag-container-default-earth)',
    selectedOptionClassName: 'bg-tag-container-inverted-earth text-tag-text-inverted-earth',
  },
  grey: {
    buttonClass:
      'bg-tag-container-default-grey border-tag-container-default-grey text-tag-text-default-grey hover:opacity-80',
    panelBg: 'var(--tag-container-default-grey)',
    panelBorder: 'var(--tag-container-default-grey)',
    selectedOptionClassName: 'bg-tag-container-inverted-grey text-tag-text-inverted-grey',
  },
  yellow: {
    buttonClass:
      'bg-tag-container-default-yellow border-tag-container-default-yellow text-tag-text-default-yellow hover:opacity-80',
    panelBg: 'var(--tag-container-default-yellow)',
    panelBorder: 'var(--tag-container-default-yellow)',
    selectedOptionClassName: 'bg-tag-container-inverted-yellow text-tag-text-inverted-yellow',
  },
  success: {
    buttonClass:
      'bg-tag-container-default-success border-tag-container-default-success text-tag-text-default-success hover:opacity-80',
    panelBg: 'var(--tag-container-default-success)',
    panelBorder: 'var(--tag-container-default-success)',
    selectedOptionClassName: 'bg-tag-container-inverted-success text-tag-text-inverted-success',
  },
  error: {
    buttonClass:
      'bg-tag-container-default-error border-tag-container-default-error text-tag-text-default-error hover:opacity-80',
    panelBg: 'var(--tag-container-default-error)',
    panelBorder: 'var(--tag-container-default-error)',
    selectedOptionClassName: 'bg-tag-container-inverted-error text-tag-text-inverted-error',
  },
  palmetto: {
    buttonClass:
      'bg-tag-container-default-palmetto border-tag-container-default-palmetto text-tag-text-default-palmetto hover:opacity-80',
    panelBg: 'var(--tag-container-default-palmetto)',
    panelBorder: 'var(--tag-container-default-palmetto)',
    selectedOptionClassName: 'bg-tag-container-inverted-palmetto text-tag-text-inverted-palmetto',
  },
};
